(function () {
  var reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)',
  ).matches;

  // ── Hero: cursor-follow spotlight (desktop only) ───────
  var heroSpot = document.querySelector('[data-hero-spotlight]');
  if (heroSpot && window.matchMedia('(hover: hover)').matches) {
    var spotPending = false;
    var spotX = 50;
    var spotY = 26;
    heroSpot.addEventListener(
      'mousemove',
      function (e) {
        var r = heroSpot.getBoundingClientRect();
        spotX = ((e.clientX - r.left) / r.width) * 100;
        spotY = ((e.clientY - r.top) / r.height) * 100;
        if (spotPending) return;
        spotPending = true;
        window.requestAnimationFrame(function () {
          heroSpot.style.setProperty('--hero-mx', spotX + '%');
          heroSpot.style.setProperty('--hero-my', spotY + '%');
          spotPending = false;
        });
      },
      { passive: true },
    );
  }

  // Showcase mockup: the screenshot auto-scrolls via CSS animation — no JS.

  // ── Graceful fallback for missing team-member photos ───
  function teamPhotoFallback(img) {
    if (!img.parentNode) return;
    var card = img.closest('.card-teammember');
    var titleEl = card && card.querySelector('.card-teammember__title');
    var name = titleEl ? titleEl.textContent.trim() : '';
    var initials = name
      .split(/\s+/)
      .slice(0, 2)
      .map(function (w) {
        return w.charAt(0);
      })
      .join('')
      .toUpperCase();
    var ph = document.createElement('span');
    ph.className = 'card-teammember__image card-teammember__image--fallback';
    ph.setAttribute('aria-hidden', 'true');
    ph.textContent = initials;
    img.replaceWith(ph);
  }

  function scanTeamPhotos() {
    document
      .querySelectorAll('img.card-teammember__image')
      .forEach(function (img) {
        if (img.complete && img.naturalWidth === 0) teamPhotoFallback(img);
      });
  }

  document
    .querySelectorAll('img.card-teammember__image')
    .forEach(function (img) {
      img.addEventListener('error', function () {
        teamPhotoFallback(img);
      });
    });
  scanTeamPhotos();
  window.addEventListener('load', scanTeamPhotos);

  // ── Scroll reveal ──────────────────────────────────────
  var revealEls = document.querySelectorAll('[data-reveal]');

  if (revealEls.length && !reduceMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('has-reveal');

    var revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry, index) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          // Small stagger for groups revealing together.
          el.style.transitionDelay = Math.min(index * 80, 240) + 'ms';
          el.classList.add('is-inview');
          observer.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' },
    );

    revealEls.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  // ── Sticky mobile CTA ──────────────────────────────────
  var sticky = document.querySelector('[data-case-sticky]');
  if (sticky) {
    var hero = document.querySelector('.ctm-block-case-hero');
    var ctaInView = false;

    // Hide the sticky bar once the page's own CTA/footer is in view.
    var ctaBlock = document.querySelector('.cta') || document.querySelector('.footer');
    if (ctaBlock && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        ctaInView = entries[0].isIntersecting;
        updateSticky();
      }, { rootMargin: '0px 0px -10% 0px' }).observe(ctaBlock);
    }

    var ticking = false;
    function updateSticky() {
      var threshold = hero ? hero.offsetHeight - 120 : 400;
      var show = window.scrollY > threshold && !ctaInView;
      sticky.classList.toggle('is-visible', show);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        updateSticky();
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    updateSticky();
  }

  // ── Count up ───────────────────────────────────────────
  var counters = document.querySelectorAll('[data-count]');
  if (!counters.length) return;

  var numberFormat = new Intl.NumberFormat('nl-NL');

  function animateCount(el) {
    var raw = (el.getAttribute('data-count') || '').trim();

    // Only animate clean numbers (optionally with dot grouping).
    if (!/^[\d.\s]+$/.test(raw)) return;

    var target = parseInt(raw.replace(/[^\d]/g, ''), 10);
    if (isNaN(target)) return;

    if (reduceMotion) {
      el.textContent = numberFormat.format(target);
      return;
    }

    var duration = 2600;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      // easeInOutCubic: calm start, soft landing
      var eased =
        progress < 0.5
          ? 4 * progress * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      el.textContent = numberFormat.format(Math.round(target * eased));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        el.textContent = numberFormat.format(target);
      }
    }

    window.requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var countObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCount(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 },
    );

    counters.forEach(function (el) {
      countObserver.observe(el);
    });
  } else {
    counters.forEach(animateCount);
  }
})();
